import ATMLoadProfileBaseController from '../common/atm_load_profile.base.controller'

class ATMLoadProfileAllController extends ATMLoadProfileBaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, Modal, $translate, $stateParams, $location) {
        super();
        // super(Auth, $state, User, ATMLoadProfileService, Modal, $translate, $stateParams, $location)
        this.hasAcl = {};
        this.$stateParams = $stateParams;
        this.User = User;
        this.branchId = this.User.getUser().branchId;
    }

    $onInit() {
        let pageId = this.$stateParams.page
        if (pageId > 0) {
            this.page = pageId;
        }
    }

    edit(atm_load_profile) {
        this.$state.go('atm_load_profile.edit', ({
            id: atm_load_profile.id
        }))
    }

    refresh() {
        this.loadData()
    }

    pageChange() {
        let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page);
        this.$stateParams.page = this.page;
        this.$location.path(newUrl);
        this.loadData();
    }

    search() {
        this.page = 1;
        let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page);
        this.$stateParams.page = this.page;
        this.$location.path(newUrl);
        this.loadData();
    }

    loadData() { }

}

export default ATMLoadProfileAllController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/atm_load_profile/all/atm_load_profile.all.controller.js